import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import "./ContactUs.css";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import API_BASE_URL from "../apiBase";

export default function Contact() {
  const initialForm = {
    name: "",
    address: "",
    phone: "",
    subject: "",
    message: "",
  };

  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    if (!form.name.trim() || !form.phone.trim() || !form.subject.trim() || !form.message.trim()) {
      setError("Name, phone, subject, and message are required.");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("address", form.address);
      formData.append("phone", form.phone);
      formData.append("subject", form.subject);
      formData.append("message", form.message);

      const res = await fetch(`${API_BASE_URL}/submit_contact.php`, {
        method: "POST",
        body: formData,
      });

      const rawText = await res.text();
      let data;
      try {
        data = JSON.parse(rawText);
      } catch {
        throw new Error(`Server returned invalid response: ${rawText.slice(0, 200)}`);
      }

      if (!res.ok || !data.success) {
        throw new Error(data.error || "Unable to send message.");
      }

      setSuccess(data.message || "Message sent successfully.");
      setForm(initialForm);
    } catch (err) {
      setError(err.message || "Unable to connect to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-us-wrapper">
      <Header />

      {/* Banner Section */}
     <section
  className="contact-banner d-flex align-items-center"
  style={{
    backgroundImage: "url('/CONTACT US.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  }}
>
  <div className="container text-center">
    <h1 className="contact-title w">Contact Us</h1>
  </div>
</section>


      {/* Contact Section */}
      <section className="py-5 contact-section-animated">
  <div className="container">
    <div className="row align-items-start">

      {/* Left Content */}
      <div className="col-lg-5 mb-4 fade-in-left">
        <h6 className="text-success fw-bold">Find Our Office</h6>
        <h2 className="fw-bold contact-heading text-dark">Contact with the team</h2>
        <p className="text-muted mb-4">
          We're here to help and answer any questions you might have. Reach out to us
        </p>

        {/* Contact Items */}
        <div className="contact-info-box mb-3 floating-box">
          <div className="d-flex">
            <span className="contact-icon me-3 green-bounce">📍</span>
            <div>
              <h6 className="fw-bold mb-1">Location</h6>
              <p className="text-muted">
                Registered Office: Plot No-196/2282, Khandagiri, Bhubaneswar-751030<br />
                Branch Office: D-2/7, Industrial Estate, Rasulgarh-751010
              </p>
            </div>
          </div>
        </div>

        <div className="contact-info-box mb-3 floating-box">
          <div className="d-flex">
            <span className="contact-icon me-3 green-bounce">📞</span>
            <div>
              <h6 className="fw-bold mb-1">Phone no</h6>
              <p className="text-muted">(+91) 9439366515</p>
            </div>
          </div>
        </div>

        <div className="contact-info-box floating-box">
          <div className="d-flex">
            <span className="contact-icon me-3 green-bounce">✉️</span>
            <div>
              <h6 className="fw-bold mb-1">Email</h6>
              <p className="text-muted">greencircleenvironment@gmail.com</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Form */}
      <div className="col-lg-7 fade-in-right">
        <div className="contact-form-box p-4 shadow-sm rounded-4 form-animate">
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            {success && (
              <div className="alert alert-success" role="alert">
                {success}
              </div>
            )}

            <div className="row g-3">
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control contact-input"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={(e) => updateField("name", e.target.value)}
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  className="form-control contact-input"
                  placeholder="Enter Address"
                  value={form.address}
                  onChange={(e) => updateField("address", e.target.value)}
                />
              </div>
            </div>

            <div className="mt-3">
              <input
                type="text"
                className="form-control contact-input"
                placeholder="Phone"
                value={form.phone}
                onChange={(e) => updateField("phone", e.target.value)}
                required
              />
            </div>

            <div className="mt-3">
              <input
                type="text"
                className="form-control contact-input"
                placeholder="Subject"
                value={form.subject}
                onChange={(e) => updateField("subject", e.target.value)}
                required
              />
            </div>

         <div className="mt-3">
  <textarea
    className="form-control contact-input textarea-large"
    placeholder="Your Message"
    value={form.message}
    onChange={(e) => updateField("message", e.target.value)}
    required
  ></textarea>
</div>


            <div className="text-start mt-4">
              <button
                type="submit"
                className="btn btn-success px-4 py-2 rounded-3 fw-semibold send-btn-animate"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</section>


      {/* Map Section */}
      {/* <section className="map-section">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.867993565889!2d-73.987155!3d40.748817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQ0JzU1LjciTiA3M8KwNTknMTMuOCJX!5e0!3m2!1sen!2sus!4v1697372200000"
          width="100%"
          height="450"
          style={{ border: "0" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section> */}
        <div className="elementor-widget-container">
    <div className="elementor-custom-embed">
      <iframe
        loading="lazy"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.1445423189325!2d85.85210257469521!3d20.294283412600688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190b0dc87c8485%3A0x9baf51bb9cd08a17!2sYUBI%20(Eat%20Healthy%20%3A%20Live%20Young)!5e0!3m2!1sen!2sin!4v1757497883452!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}   // ✅ fixed for JSX
        allowFullScreen
        title="Odisha, India"
        aria-label="Bhubaneswar, India"
      ></iframe>
    </div>
  </div>
      <Footer />
    </div>
  );
}
